/**
 * Component Sort by
 * 
 * @module component-sort-by
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-sort-by';

 if (!customElements.get(customElements.component)) {

    class componentSortBy extends HTMLElement {
 
    /**
     * Sort By web component.
     * 
     * @constructor
     */
    constructor() {

    super();
    
    this.initEvents();
    }

	/**
	 * Init module
	 */
     initEvents()  {

        this.initSortBy();
        this.CalculateBoxSize();
	}

    /**
	 * Calculate deposit box size
	 */

     CalculateBoxSize() {
        var exchange_number = 56;
        var multiplier = 5;
        var select = document.getElementById("sort-by");
        const helperElement = document.querySelector(".helper-element");

        helperElement.innerHTML = select.options[select.selectedIndex].innerHTML;
        const root = document.documentElement;
        
        if(helperElement.offsetWidth > 75){
            root.style.setProperty("--dynamic-size", helperElement.offsetWidth + 10 + `px`);

            var decimal = helperElement.offsetWidth / exchange_number - Math.floor(helperElement.offsetWidth / exchange_number);
            if(decimal > 0 ){
                root.style.setProperty("--arrow-size", Math.trunc((helperElement.offsetWidth / exchange_number) +1 ) * multiplier + `px`);
            }else{
                root.style.setProperty("--arrow-size", Math.trunc((helperElement.offsetWidth / exchange_number)) * multiplier + `px`);
            }

        }else{
            root.style.setProperty("--dynamic-size", helperElement.offsetWidth + `px`);
        }
        
    }
      

    /**
	 * Init Sort by
	 */
    initSortBy() {

        let select = this.querySelectorAll("select");

        select.forEach((element) => {

            element.addEventListener('change', (event) => {
                this.CalculateBoxSize();
                let sort_by_value = element.value || element.defaultSort;
                let urlSearchParams = new URLSearchParams(window.location.search);

                if (urlSearchParams.has('page') == true) {
                    urlSearchParams.delete('page');
                }

                urlSearchParams.set("sort_by", sort_by_value);
                window.location.search = urlSearchParams.toString();

            });
            
        });
    }

    }

    customElements.define(customElements.component, componentSortBy);
}
